import { styled } from '@mui/material/styles';
import Switch from '@mui/material/Switch';
import { useGlobalContext } from '../Context/GlobalContext';

const Toggle = ({
    value,
    setValue,
    rightLabel,
    leftLabel,
    title,
    withIcons,
}: {
    value: boolean,
    setValue: (value: boolean) => void,
    rightLabel?: string,
    leftLabel?: string,
    title?: string,
    withIcons?: boolean,
}) => {
  const { getThemeStyles } = useGlobalContext(); 
  const styles = getThemeStyles();
  return (
    <>
      {title && <div className="toggle-label">{title}</div>}
      <div className="toggle-wrapper">
        <div>{leftLabel}</div>
          { 
            withIcons ?
            <>
              {!value && <svg 
                xmlns="http://www.w3.org/2000/svg" 
                height="15" 
                width="15" 
                viewBox="0 0 20 20"
                style={{ position: 'absolute', top: '5px', right: '9px', zIndex: 1, cursor: 'pointer' }}
                onClick={() => setValue(!value)}
              >
                <path 
                  fill={styles['--theme-color']}
                  d="M9.305 1.667V3.75h1.389V1.667h-1.39zm-4.707 1.95l-.982.982L5.09 6.072l.982-.982-1.473-1.473zm10.802 0L13.927 5.09l.982.982 1.473-1.473-.982-.982zM10 5.139a4.872 4.872 0 00-4.862 4.86A4.872 4.872 0 0010 14.862 4.872 4.872 0 0014.86 10 4.872 4.872 0 0010 5.139zm0 1.389A3.462 3.462 0 0113.471 10a3.462 3.462 0 01-3.473 3.472A3.462 3.462 0 016.527 10 3.462 3.462 0 0110 6.528zM1.665 9.305v1.39h2.083v-1.39H1.666zm14.583 0v1.39h2.084v-1.39h-2.084zM5.09 13.928L3.616 15.4l.982.982 1.473-1.473-.982-.982zm9.82 0l-.982.982 1.473 1.473.982-.982-1.473-1.473zM9.305 16.25v2.083h1.389V16.25h-1.39z"
                />
              </svg>}
              <SwitchWithIcons checked={value} onChange={(e: any) => setValue(e.target.checked)}/>
              {value && <svg 
                xmlns="http://www.w3.org/2000/svg" 
                height="15" 
                width="15" 
                viewBox="0 -960 960 960"
                style={{ position: 'absolute', top: '5px', left: '9px', zIndex: 1, cursor: 'pointer' }}
                onClick={() => setValue(!value)}
              >
                <path 
                  fill={styles['--theme-color']}
                  d="M480-120q-150 0-255-105T120-480q0-150 105-255t255-105q14 0 27.5 1t26.5 3q-41 29-65.5 75.5T444-660q0 90 63 153t153 63q55 0 101-24.5t75-65.5q2 13 3 26.5t1 27.5q0 150-105 255T480-120Zm0-80q88 0 158-48.5T740-375q-20 5-40 8t-40 3q-123 0-209.5-86.5T364-660q0-20 3-40t8-40q-78 32-126.5 102T200-480q0 116 82 198t198 82Zm-10-270Z"
                />
              </svg>}
            </>

            :
            <SwitchWithoutIcons checked={!value} onChange={(e: any) => setValue(!e.target.checked)}/>
          }
        <div>{rightLabel}</div>
      </div>
    </>
  );
};

const SwitchWithIcons = styled((props: any) => (
  <>
    <Switch focusVisibleClassName=".Mui-focusVisible" disableRipple {...props} />
  </>
))(({ theme }) => { 
  const { getThemeStyles } = useGlobalContext(); 
  const styles = getThemeStyles();
  return {
  width: 50,
  height: 22,
  padding: 0,
  overflow: "visible",
  "& .MuiSwitch-switchBase": {
    padding: 0,
    margin: 2,
    transitionDuration: "300ms",
    "&.Mui-checked": {
      transform: "translateX(22px)",
      '& .MuiSwitch-thumb:before': {
        backgroundImage: `url('data:image/svg+xml;utf8,<svg xmlns="http://www.w3.org/2000/svg" height="15" width="15" viewBox="0 0 20 20"><path fill="${encodeURIComponent(
          styles['--theme-bg-color'],
        )}" d="M9.305 1.667V3.75h1.389V1.667h-1.39zm-4.707 1.95l-.982.982L5.09 6.072l.982-.982-1.473-1.473zm10.802 0L13.927 5.09l.982.982 1.473-1.473-.982-.982zM10 5.139a4.872 4.872 0 00-4.862 4.86A4.872 4.872 0 0010 14.862 4.872 4.872 0 0014.86 10 4.872 4.872 0 0010 5.139zm0 1.389A3.462 3.462 0 0113.471 10a3.462 3.462 0 01-3.473 3.472A3.462 3.462 0 016.527 10 3.462 3.462 0 0110 6.528zM1.665 9.305v1.39h2.083v-1.39H1.666zm14.583 0v1.39h2.084v-1.39h-2.084zM5.09 13.928L3.616 15.4l.982.982 1.473-1.473-.982-.982zm9.82 0l-.982.982 1.473 1.473.982-.982-1.473-1.473zM9.305 16.25v2.083h1.389V16.25h-1.39z"/></svg>')`,
      },
      color: "black",
      "& + .MuiSwitch-track": {
        backgroundColor: styles['--theme-bg-color'],
        opacity: 1,
        ...theme.applyStyles("dark", {
          backgroundColor: "black",
        }),
      },
      "&.Mui-disabled + .MuiSwitch-track": {
        opacity: 0.5,
      },
    },
    "&.Mui-focusVisible .MuiSwitch-thumb": {
      color: "#7ECAAA",
      border: "6px solid #7ECAAA",
    },
    "&.Mui-disabled .MuiSwitch-thumb": {
      color: theme.palette.grey[100],
      ...theme.applyStyles("dark", {
        color: theme.palette.grey[600],
      }),
    },
    "&.Mui-disabled + .MuiSwitch-track": {
      opacity: 0.7,
      ...theme.applyStyles("dark", {
        opacity: 0.3,
      }),
    },
  },
  "& .MuiSwitch-thumb": {
    boxSizing: "border-box",
    width: 20,
    height: 20,
    color: styles['--theme-color'],
    '&::before': {
      content: "''",
      position: 'absolute',
      width: '100%',
      height: '100%',
      left: 0,
      top: 0,
      backgroundRepeat: 'no-repeat',
      backgroundPosition: 'center',
      backgroundImage: `url('data:image/svg+xml;utf8,<svg xmlns="http://www.w3.org/2000/svg" width="15" height="15" viewBox="0 -960 960 960"><path fill="${encodeURIComponent(
        styles['--theme-bg-color']
      )}" d="M480-120q-150 0-255-105T120-480q0-150 105-255t255-105q14 0 27.5 1t26.5 3q-41 29-65.5 75.5T444-660q0 90 63 153t153 63q55 0 101-24.5t75-65.5q2 13 3 26.5t1 27.5q0 150-105 255T480-120Zm0-80q88 0 158-48.5T740-375q-20 5-40 8t-40 3q-123 0-209.5-86.5T364-660q0-20 3-40t8-40q-78 32-126.5 102T200-480q0 116 82 198t198 82Zm-10-270Z"/></svg>')`,
    },
  },
  "& .MuiSwitch-track": {
    borderRadius: 30 / 2,
    backgroundColor: styles['--theme-bg-color'],
    opacity: 1,
    transition: theme.transitions.create(["background-color"], {
      duration: 500,
    }),
    border: '1px solid ' + styles['--theme-color'],
  },
}});

const SwitchWithoutIcons = styled((props: any) => (
  <Switch focusVisibleClassName=".Mui-focusVisible" disableRipple {...props} />
))(({ theme }) => { 
const { getThemeStyles } = useGlobalContext(); 
const styles = getThemeStyles();
return {
width: 40,
height: 17,
padding: 0,
overflow: "visible",
"& .MuiSwitch-switchBase": {
  padding: 0,
  margin: 2,
  transitionDuration: "300ms",
  "&.Mui-checked": {
    transform: "translateX(17px)",
    color: styles['--theme-bg-color'],
    "& + .MuiSwitch-track": {
      backgroundColor: styles['--theme-bg-color'],
      opacity: 1,
    },
    "&.Mui-disabled + .MuiSwitch-track": {
      opacity: 0.5,
    },
  },
  "&.Mui-focusVisible .MuiSwitch-thumb": {
    color: styles['--theme-color'],
    border: "6px solid " + styles['--theme-color'],
  },
},
"& .MuiSwitch-thumb": {
  boxSizing: "border-box",
  width: 15,
  height: 15,
  color: styles['--theme-color'],
},
"& .MuiSwitch-track": {
  borderRadius: 30 / 2,
  backgroundColor: styles['--theme-bg-color'],
  opacity: 1,
  transition: theme.transitions.create(["background-color"], {
    duration: 500,
  }),
  border: '1px solid ' + styles['--theme-color'],
},
}});

export default Toggle;
